import { Tooltip, TooltipTrigger, TooltipContent } from 'src/registry/ui/Tooltip';

export const getTooltipCell = ({ value }: { value: string }) => {
    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <div className="block max-w-32 cursor-pointer truncate">{value}</div>
            </TooltipTrigger>
            <TooltipContent className="hidden h-auto max-w-xs break-words whitespace-normal sm:block" side="left">
                <p>{value}</p>
            </TooltipContent>
        </Tooltip>
    );
};
